import {
  BASE_DIALOG_DEFAULT_CONFIG,
  BaseDialog,
  BaseDialogDefinition,
  BaseDialogIngredients,
  SMALL_DIALOG_CONFIG,
  ValueCalculator
} from '@aviary/dialogs/base-dialog/base-dialog.types';
import {MatDialogConfig} from '@angular/material/dialog';

export const DEFAULT_CONFIRMATION_CANCEL_BUTTON_LABEL: string = 'Cancel';
export const DEFAULT_CONFIRMATION_CONFIRM_BUTTON_LABEL: string = 'Confirm';

export type DefaultConfirmationValueType = true;
export const DEFAULT_CONFIRMATION_VALUE_CALCULATOR: ValueCalculator<DefaultConfirmationValueType> = () => true;

export type ConfirmationDialogDefinition<ValueType = DefaultConfirmationValueType> = Omit<BaseDialogDefinition<ValueType>, 'valueCalculator'> & {
  valueCalculator?: ValueCalculator<ValueType>;
};

export interface ConfirmationDialog<DataType, ValueType = DefaultConfirmationValueType> extends BaseDialog<DataType, ValueType> {
  readonly dialogDefinition: ConfirmationDialogDefinition<ValueType>;
}

export const CONFIRMATION_DIALOG_DEFAULT_CONFIG: MatDialogConfig = {
  ...BASE_DIALOG_DEFAULT_CONFIG,
  ...SMALL_DIALOG_CONFIG
};

export type ConfirmationDialogIngredients<DataType, ValueType, DialogComponent extends ConfirmationDialog<DataType, ValueType>> =
  BaseDialogIngredients<DataType, ValueType, DialogComponent>;

export interface SimpleConfirmationDialogData {
  title: string;
  description?: string;
  prompt?: string;
  cancelButtonLabel?: string;
  confirmButtonLabel?: string;
}
